/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Attachments/view.blocks to change it.
import * as fromData from 'Simple/Data'
import CommsThreadEventAttachments from 'DesignSystem/CommsThreadEventAttachments/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Attachments({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/InApp/Content/Inbound/Attachments"
  
}) {
let inAppIdValueData = fromData.useDataValue({ viewPath,
context: 'in_app',
path: 'id',
})
  return (<React.Fragment
>
<CommsThreadEventAttachments
  viewPath={`${viewPath}/CommsThreadEventAttachments`}
 data="in_app.id"
 event_id={inAppIdValueData}
/>
{children}
</React.Fragment>)
}